// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import FileIcon from "@insite/mobius/Icons/File";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { FormFieldUploadedFileType } from "@store/Framework/Types/FormField";
import Close from "@store/Library/Components/Toolkit/Icons/Close";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import { css } from "styled-components";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Clickable, { ClickablePresentationProps, ClickableProps } from "@insite/mobius/Clickable";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { spacingStyles } from "@toolkit/Themes/common/mixins";

export interface FormFieldUploadedFilePresentationProps extends ExpandStyles<FormFieldUploadedFileStyles> {}

export interface FormFieldUploadedFileProps extends FormFieldUploadedFilePresentationProps {
    file: FormFieldUploadedFileType;
    onRemoveClick?: ClickableProps["onClick"];
}

export interface FormFieldUploadedFileStyles {
    icon?: IconPresentationProps;
    name?: TypographyPresentationProps;
    removeClickable?: ClickablePresentationProps;
    removeIcon?: IconPresentationProps;
    wrapper?: InjectableCss;
}

export const formFieldUploadedFileStyles: FormFieldUploadedFileStyles = {
    wrapper: {
        css: css`
            ${spacingStyles(null, pxToRem(8))}
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: ${pxToRem(4)};
            border: 1px solid ${getColor("common.border")};
            border-radius: ${pxToRem(4)};
            background-color: ${getColor("common.background")};
            padding: ${pxToRem(6, 8)};
        `,
    },
    icon: {
        color: "text.light",
        size: 18,
        src: FileIcon,
        css: css`
            flex-shrink: 0;
        `,
    },
    name: {
        css: css`
            flex-grow: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        `,
    },
    removeClickable: {
        css: css`
            flex-shrink: 0;
            color: ${getColor("text.light")};
            transition: ${transitionHoverStyles("color")};

            &:hover,
            &:active {
                color: ${getColor("text.main")};
            }
        `,
    },
    removeIcon: {
        color: "inherit",
        size: 14,
        src: Close,
    },
};

const FormFieldUploadedFile: FC<FormFieldUploadedFileProps> = ({
    file: { fileName },
    extendedStyles,
    onRemoveClick,
    overridedStyles,
}) => {
    const styles = useExpandProps(formFieldUploadedFileStyles, extendedStyles, overridedStyles);

    return (
        <StyledWrapper {...styles.wrapper}>
            <Icon {...styles.icon} />
            <Typography {...styles.name}>{fileName}</Typography>
            {onRemoveClick && (
                <Clickable
                    {...styles.removeClickable}
                    aria-label={translate("Remove {0}", fileName)}
                    onClick={onRemoveClick}
                >
                    <Icon {...styles.removeIcon} />
                </Clickable>
            )}
        </StyledWrapper>
    );
};

export default FormFieldUploadedFile;
